import {getMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/customProductInfo', request)
}

async function put(id, request) {
    return await putMethod(`/api/customProductInfo/${id}`, request)
}

export {get, put}
